
    import './styles.scoped.css';
    export default {
  "drawer": "awsui_drawer_1r9lg_1c5a9_201",
  "refresh": "awsui_refresh_1r9lg_1c5a9_201",
  "animating": "awsui_animating_1r9lg_1c5a9_215",
  "preference-icon--svg": "awsui_preference-icon--svg_1r9lg_1c5a9_328",
  "preference-icon--layout-border": "awsui_preference-icon--layout-border_1r9lg_1c5a9_331",
  "preference-icon--layout-background": "awsui_preference-icon--layout-background_1r9lg_1c5a9_335",
  "preference-icon--layout-header": "awsui_preference-icon--layout-header_1r9lg_1c5a9_338",
  "preference-icon--border": "awsui_preference-icon--border_1r9lg_1c5a9_341",
  "preference-icon--primary-button": "awsui_preference-icon--primary-button_1r9lg_1c5a9_345",
  "preference-icon--secondary": "awsui_preference-icon--secondary_1r9lg_1c5a9_348",
  "preference-icon--disabled-element": "awsui_preference-icon--disabled-element_1r9lg_1c5a9_351",
  "preference-icon--separator": "awsui_preference-icon--separator_1r9lg_1c5a9_354",
  "preference-icon--focus-text": "awsui_preference-icon--focus-text_1r9lg_1c5a9_357",
  "preference-icon-refresh--svg": "awsui_preference-icon-refresh--svg_1r9lg_1c5a9_361",
  "preference-icon-refresh--layout-top": "awsui_preference-icon-refresh--layout-top_1r9lg_1c5a9_364",
  "preference-icon-refresh--layout-main": "awsui_preference-icon-refresh--layout-main_1r9lg_1c5a9_367",
  "preference-icon-refresh--primary": "awsui_preference-icon-refresh--primary_1r9lg_1c5a9_370",
  "preference-icon-refresh--disabled": "awsui_preference-icon-refresh--disabled_1r9lg_1c5a9_373",
  "preference-icon-refresh--column-header": "awsui_preference-icon-refresh--column-header_1r9lg_1c5a9_376",
  "preference-icon-refresh--window": "awsui_preference-icon-refresh--window_1r9lg_1c5a9_379",
  "preference-icon-refresh--secondary": "awsui_preference-icon-refresh--secondary_1r9lg_1c5a9_383",
  "preference-icon-refresh--default": "awsui_preference-icon-refresh--default_1r9lg_1c5a9_386",
  "preference-icon-refresh--separator": "awsui_preference-icon-refresh--separator_1r9lg_1c5a9_389",
  "preference-icon-refresh--input-default": "awsui_preference-icon-refresh--input-default_1r9lg_1c5a9_392",
  "preference-icon-refresh--heading": "awsui_preference-icon-refresh--heading_1r9lg_1c5a9_395",
  "root": "awsui_root_1r9lg_1c5a9_399",
  "preferences-button": "awsui_preferences-button_1r9lg_1c5a9_434",
  "close-button": "awsui_close-button_1r9lg_1c5a9_438",
  "drawer-closed": "awsui_drawer-closed_1r9lg_1c5a9_450",
  "drawer-content-side": "awsui_drawer-content-side_1r9lg_1c5a9_455",
  "drawer-content-bottom": "awsui_drawer-content-bottom_1r9lg_1c5a9_471",
  "position-bottom": "awsui_position-bottom_1r9lg_1c5a9_478",
  "position-side": "awsui_position-side_1r9lg_1c5a9_505",
  "slider": "awsui_slider_1r9lg_1c5a9_511",
  "slider-side": "awsui_slider-side_1r9lg_1c5a9_546",
  "slider-wrapper-bottom": "awsui_slider-wrapper-bottom_1r9lg_1c5a9_553",
  "slider-wrapper-side": "awsui_slider-wrapper-side_1r9lg_1c5a9_564",
  "open-button": "awsui_open-button_1r9lg_1c5a9_575",
  "open-button-side": "awsui_open-button-side_1r9lg_1c5a9_579",
  "slider-icon": "awsui_slider-icon_1r9lg_1c5a9_588",
  "slider-icon-bottom": "awsui_slider-icon-bottom_1r9lg_1c5a9_594",
  "slider-icon-side": "awsui_slider-icon-side_1r9lg_1c5a9_598",
  "pane-header-wrapper-bottom": "awsui_pane-header-wrapper-bottom_1r9lg_1c5a9_602",
  "drawer-mobile": "awsui_drawer-mobile_1r9lg_1c5a9_613",
  "drawer-disable-content-paddings": "awsui_drawer-disable-content-paddings_1r9lg_1c5a9_617",
  "content-bottom": "awsui_content-bottom_1r9lg_1c5a9_626",
  "pane-bottom-center-align": "awsui_pane-bottom-center-align_1r9lg_1c5a9_642",
  "pane-bottom-content-nav-padding": "awsui_pane-bottom-content-nav-padding_1r9lg_1c5a9_647",
  "pane-bottom-content-tools-padding": "awsui_pane-bottom-content-tools-padding_1r9lg_1c5a9_651",
  "content-bottom-max-width": "awsui_content-bottom-max-width_1r9lg_1c5a9_655",
  "content-side": "awsui_content-side_1r9lg_1c5a9_660",
  "pane-header-wrapper-side": "awsui_pane-header-wrapper-side_1r9lg_1c5a9_670",
  "pane-content-wrapper-side": "awsui_pane-content-wrapper-side_1r9lg_1c5a9_676",
  "header": "awsui_header_1r9lg_1c5a9_683",
  "header-text": "awsui_header-text_1r9lg_1c5a9_693",
  "header-actions": "awsui_header-actions_1r9lg_1c5a9_706",
  "divider": "awsui_divider_1r9lg_1c5a9_714"
};
  